// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Get environment from build-time environment variable (for S3 deployments)
// Fallback to git branch detection for local development
const environment = process.env.REACT_APP_ENVIRONMENT || 
                   (process.env.REACT_APP_GIT_BRANCH === 'main' ? 'production' : 'development');
const isProduction = environment === 'production';

console.log('🔥 Firebase Environment Detection:');
console.log('REACT_APP_ENVIRONMENT:', process.env.REACT_APP_ENVIRONMENT);
console.log('REACT_APP_GIT_BRANCH:', process.env.REACT_APP_GIT_BRANCH);
console.log('Detected Environment:', environment);
console.log('Is Production:', isProduction);

// Firebase configuration based on environment
const firebaseConfig = isProduction ? {
  // Production Firebase config
  apiKey: process.env.REACT_APP_PROD_FIREBASE_API_KEY || "AIzaSyDEa8Tfr4enAgJs3BDD26HoKS5g9hkvfQE",
  authDomain: process.env.REACT_APP_PROD_FIREBASE_AUTH_DOMAIN || "nfbd-scheduler-app.firebaseapp.com",
  projectId: process.env.REACT_APP_PROD_FIREBASE_PROJECT_ID || "nfbd-scheduler-app",
  storageBucket: process.env.REACT_APP_PROD_FIREBASE_STORAGE_BUCKET || "nfbd-scheduler-app.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_PROD_FIREBASE_MESSAGING_SENDER_ID || "980409275350",
  appId: process.env.REACT_APP_PROD_FIREBASE_APP_ID || "1:980409275350:web:82b4576d185466384aca77",
} : {
  // Development Firebase config
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyB5UAJSic0skTLEltBegGsnzLD05eqalBk",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "nfbd-scheduler-dev.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "nfbd-scheduler-dev",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "nfbd-scheduler-dev.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1043610659957",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1043610659957:web:a04b9631bbf12920169c3c",
};

console.log('🔥 Selected Firebase Configuration:');
console.log('Project ID:', firebaseConfig.projectId);
console.log('Auth Domain:', firebaseConfig.authDomain);
console.log('App ID:', firebaseConfig.appId);
console.log('Storage Bucket:', firebaseConfig.storageBucket);
console.log('Messaging Sender ID:', firebaseConfig.messagingSenderId);

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app); // ✅ use this for Firestore
export const auth = getAuth(app);     // ✅ use this if you need Firebase Auth